import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "../lib/cn.js";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  readonly invalid?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, invalid, rows = 3, ...rest }, ref) {
    return (
      <textarea
        ref={ref}
        rows={rows}
        aria-invalid={invalid === true ? true : undefined}
        className={cn(
          "w-full rounded-md border px-3 py-3 text-base",
          "bg-elevated text-fg placeholder:text-dim",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-1",
          "disabled:cursor-not-allowed disabled:opacity-50",
          invalid === true
            ? "border-danger focus-visible:ring-danger"
            : "border-line",
          className,
        )}
        {...rest}
      />
    );
  },
);
